import * as React from 'react';

import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';

import { ListWrapper } from './components/list-wrapper';
import { ListRenderer } from './components/list-renderer';
import { actionCreators } from './actions';
import { dashboardAdminTranslation } from '../constants';
import { DashboardAdminState } from '../types-store';
import { scrollToTop } from 'app/infrastructure/platform/routing';

export type DashboardAdminListProps = DefaultContainerProps
  & DashboardAdminState
  & typeof actionCreators;

class DashboardAdminListComponent extends React.PureComponent<DashboardAdminListProps> {
  public static statePath: string = STATE.dashboardAdministration;

  public componentWillUnmount() {
    this.props.clearList();
  }

  public componentDidMount() {
    scrollToTop();
  }

  public render() {

    const { list, loadList, deleteDashboard, displayError, sharedState, translation } = this.props;

    return <ListWrapper
      displayError={displayError}
      sharedState={sharedState}
      translation={translation}>
      <ListRenderer
        listState={list}
        loadList={loadList}
        deleteDashboard={deleteDashboard}
        translation={translation}
      />
    </ListWrapper>;
  }
}

const container = containerFactory(DashboardAdminListComponent, actionCreators, undefined, dashboardAdminTranslation);

export { container as DashboardAdminList };
